import moment from "moment/moment";

export function localizedTimeToTest(time: any) {
  return moment.utc(time).local().format("hh:mma on MMMM Do, YYYY");
}

/**
 * Formats a UTC datetime string as a clean date for test scheduling display.
 * Tests are day-aligned to Pacific midnight, so showing only the date is more
 * meaningful than showing a specific local time like "2:00 AM".
 */
export function formatTestDate(time: any): string {
  return moment.utc(time).local().format("MMM Do, YYYY");
}

export type TestVariantStatus = "scheduled" | "running" | "completed";

/**
 * Derives the display status of a test variant from its boolean flags.
 * - scheduled: queued but not yet active (in limbo waiting for its day window)
 * - running: currently active
 * - completed: finished
 */
export function getTestVariantStatus(test: { active: boolean; tested: boolean }): TestVariantStatus {
  if (test.tested) return "completed";
  if (test.active) return "running";
  return "scheduled";
}


export function calculateDaysHoursYearsAgo(date: Date) {
  const now = new Date();
  const then = new Date(date);
  // console.log({now, date});
  const diff = now.getTime() - then.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
  if (years > 0) {
    return `${years} years ago`;
  }
  if (days > 0) {
    return `${days} days ago`;
  }
  if (hours > 0) {
    return `${hours} hours ago`;
  }
  if (minutes > 0) {
    return `${minutes} minutes ago`;
  }
  return `${seconds} seconds ago`;
};
